// extracted by mini-css-extract-plugin
export default {"EmptyState":"_EmptyState--v49J1","EmptyStateMobile":"_EmptyStateMobile--MddC1"};